import { FlowComponent } from '../../flow.min.js';
import tailwindSheet from '../../styles.js';
import Helium from '../../helium.min.js';
import { createAuthService } from '../../services/auth.service.js';
import { createDashboardService } from '../../services/dashboard.service.js';
import { createAccountsService } from '../../services/accounts.service.js';
import { createSubscriptionsService } from '../../services/subscriptions.service.js';
import { createPlansService } from '../../services/plans.service.js';
import { createFeaturesService } from '../../services/features.service.js';
import { createAlertsService } from '../../services/alerts.service.js';
import { createUIService } from '../../services/ui.service.js';

const template = FlowComponent.html`<slot></slot>`;

export class AdminRoot extends FlowComponent {
	static get template() { return template; }
	
	onMount() {
		super.onMount();
		this.root.adoptedStyleSheets = [tailwindSheet];
		
		this.helium = new Helium();
		
		this.helium.services = {
			auth: createAuthService(this.helium),
			dashboard: createDashboardService(this.helium),
			accounts: createAccountsService(this.helium),
			subscriptions: createSubscriptionsService(this.helium),
			plans: createPlansService(this.helium),
			features: createFeaturesService(this.helium),
			alerts: createAlertsService(this.helium),
			ui: createUIService(this.helium)
		};
		
		const sessionChannel = this.helium.factory('auth:session');
		
		sessionChannel.bind(this, (el, user) => {
			if (user?.isSaasAdmin) {
				this.navigate('dashboard');
			} else {
				this.navigate('login');
			}
		});
		
		this.#checkAuth();
	}
	
	async #checkAuth() {
		const token = sessionStorage.getItem('adminToken');
		if (token) {
			try {
				const user = await this.helium.services.auth.getCurrentUser();
				if (user?.isSaasAdmin) {
					return;
				}
			} catch (error) {
				console.warn('Token validation failed:', error);
			}
		}
		sessionStorage.removeItem('adminToken');
		const sessionChannel = this.helium.factory('auth:session');
		sessionChannel.send(() => null);
	}
	
	async navigate(view) {
		this.innerHTML = '';
		
		if (view === 'login') {
			await import('../admin-login/admin-login.js');
			const login = document.createElement('admin-login');
			login.helium = this.helium;
			this.appendChild(login);
		} else {
			await import('../admin-alerts/admin-alerts.js');
			const alerts = document.createElement('admin-alerts');
			alerts.helium = this.helium;
			this.appendChild(alerts);
			
			await import('../admin-layout/admin-layout.js');
			const layout = document.createElement('admin-layout');
			layout.helium = this.helium;
			this.appendChild(layout);
		}
	}
}

customElements.define('admin-root', AdminRoot);
